export default async (to, from, savedPosition) => {
      if (savedPosition) {
        return savedPosition;
      }

      const findEl = async (hash, x) => {
        return (
          document.querySelector(hash) ||
          new Promise((resolve) => {
            if (x > 50) {
              return resolve();
            }
            setTimeout(() => {
              resolve(findEl(hash, ++x || 1));
            }, 1000);
          }));
      };

      if (to.hash) {
        const el = await findEl(to.hash);
        if ('scrollBehavior' in document.documentElement.style) {
          let distance = 0;
          if (to.name != from.name) distance = 590;
          return window.scrollTo({
            top: el.offsetTop + distance,
            behavior: 'smooth'
          });
        } else {
          return window.scrollTo(0, el.offsetTop);
        }
      }
      return { x: 0, y: 0 };
    }
